import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['personIcon', 'groupIcon'];

  static values = {
    attributeNameForVal: String,
    groupTag: String
  };

  // Val represents the @pill[value]

  attributeNameForValValueChanged() {
    if (this.isValGroup()) {
      this.groupIconTarget.classList.remove('hidden')
      this.personIconTarget.classList.add('hidden')
    } else {
      this.groupIconTarget.classList.add('hidden')
      this.personIconTarget.classList.remove('hidden')
    }
  }

  isValGroup() {
    if (this.hasAttributeNameForValValue && this.hasGroupTagValue) {
      const val = this.element.getAttribute(this.attributeNameForValValue) || ''
      return val.includes(this.groupTagValue)
    }
    return false
  }
}
